import { datasourceTableStrokedIcon } from '@y42/feature/icons';
import { Binding, GraphObject, Margin, Picture, Spot } from 'gojs';
import { dataLineageButtons, DataLineageUINode, LINEAGE_PARTS } from '../../../../../../../state/data-lineage-diagram';
import { buttonToolTip } from './tooltip';

const $ = GraphObject.make;

export const tableButton = (bindings: go.Binding[] = []) =>
  $(
    'Button',
    {
      name: LINEAGE_PARTS.SHOW_TABLE_BUTTON,
      'ButtonBorder.spot1': Spot.TopLeft,
      'ButtonBorder.spot2': Spot.BottomRight,
      'ButtonBorder.stroke': 'transparent',
      'ButtonBorder.fill': dataLineageButtons.overview.border,
      _buttonFillOver: dataLineageButtons.overview.hover.fill,
      _buttonStrokeOver: dataLineageButtons.overview.hover.border,
      _buttonFillPressed: 'transparent',
      _buttonStrokePressed: 'transparent',
      _buttonFillDisabled: 'transparent',
      toolTip: buttonToolTip('Show Table', 'You do not have read access to this asset'),
      width: 20,
      height: 20,
      margin: new Margin(0, 0, 0, 10),
    },
    buttonPicture(),
    ...bindings,
    isEnabledBinding(),
  );

const buttonPicture = () =>
  $(Picture, {
    source: datasourceTableStrokedIcon,
  });

const isEnabledBinding = () =>
  new Binding('isEnabled', '', (node: DataLineageUINode) => !!node.validColumnsCount && node.hasReadPermission);
